import {UppercaseDirective} from '../../UppercaseDirective'
import {NgModule} from '@angular/core';

@NgModule({
    declarations: [UppercaseDirective],
    exports: [UppercaseDirective],
})

export class UpperCaseModule {

}


// WEBPACK FOOTER //
// D:/ESealStore_AJS/src/app/components/lazyloader/UpperCaseModule.ts